import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Spinner,
  ProgressBar,
  Badge,
  Table,
} from "react-bootstrap";
import Select from "react-select";
import DataApi from "../../api/dataApi";
import helper from "../common/helper";
import PubSub from "pubsub-js";
import * as constants from "../../constants/CONSTANT";

const BulkIssue = ({ permissions, fetchIssuedBooks }) => {
  const [books, setBooks] = useState([]);
  const [bookCopies, setBookCopies] = useState([]);
  const [libraryCards, setLibraryCards] = useState([]);
  const [issuedBooks, setIssuedBooks] = useState([]);
  const [users, setUsers] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [plans, setPlans] = useState([]);
  const [librarySettings, setLibrarySettings] = useState(null);
  const [isBookBankMode, setIsBookBankMode] = useState(false);
  const [manualBookBankMode, setManualBookBankMode] = useState(false);

  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [selectedCopies, setSelectedCopies] = useState({});

  const [durationDays, setDurationDays] = useState(15);
  const [systemMaxBooks, setSystemMaxBooks] = useState(6);
  const [memberExtraAllowance, setMemberExtraAllowance] = useState(0);
  const [totalAllowedBooks, setTotalAllowedBooks] = useState(6);
  const [dailyLimitCount, setDailyLimitCount] = useState(2);
  const [bookBankLimit, setBookBankLimit] = useState(0);

  const [subscriptionAllowedBooks, setSubscriptionAllowedBooks] = useState(0);
  const [memberPersonalAllowedBooks, setMemberPersonalAllowedBooks] = useState(0);
  const [memberSubscription, setMemberSubscription] = useState(null);
  const [memberPlan, setMemberPlan] = useState(null);
  
  const [issueDate, setIssueDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [dueDate, setDueDate] = useState("");
  const [confirmDays, setConfirmDays] = useState(0);
  const [autoCalculated, setAutoCalculated] = useState(false);

  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [memberInfo, setMemberInfo] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [memberAge, setMemberAge] = useState(null);
  const [filteredBooksByAge, setFilteredBooksByAge] = useState([]);
  const [filteredCopiesByAge, setFilteredCopiesByAge] = useState([]);
  const [showIssuedBooks, setShowIssuedBooks] = useState(false);
  const [company, setCompany] = useState(false);
  const [companybookbank, setCompanybookbank] = useState(false);

  const [selectInputValue, setSelectInputValue] = useState("");
  const debounceTimer = useRef(null);

  const [bookSearchTerm, setBookSearchTerm] = useState('');
  const [bookPage, setBookPage] = useState(0);
  const [bookHasMore, setBookHasMore] = useState(true);
  const [bookLoading, setBookLoading] = useState(false);
  const [bookLoadingMore, setBookLoadingMore] = useState(false);
  const [paginatedBookCopies, setPaginatedBookCopies] = useState([]);

  const requestRef = useRef(0);

  const effectiveBookBankMode = manualBookBankMode;


   const loadLibrarySettings = async () => {
      try {
        const api = new DataApi("librarysettings");
        const resp = await api.get("/all");
        console.log("Library settings response:", resp);
        let settings = {};
        if (resp.data && resp.data.success) {
          settings = resp.data.data || {};
        } else if (resp.data) {
          settings = resp.data;
        }
        // if array wrap
        if (Array.isArray(settings)) settings = settings[0] || {};
        setLibrarySettings(settings);
      } catch (e) {
        console.error("Error loading library settings:", e);
      }
    };

     useEffect(() => {
        loadLibrarySettings();
      }, []);


       const callNumberLabel = librarySettings?.call_number_label || "Call Number";
     console.log("librarySettings", librarySettings);

  const fetchLibrarySettings = async () => {
    try {
      const api = new DataApi("librarysettings");
      const resp = await api.get("/all");

      let settings = {};
      if (resp.data && resp.data.success) {
        settings = resp.data.data || {};
      } else if (resp.data) {
        settings = resp.data;
      }

      if (Array.isArray(settings)) settings = settings[0] || {};

      setLibrarySettings(settings);
      setIsBookBankMode(settings.book_bank === true);
      setBookBankLimit(parseInt(settings.book_bank_books_limit) || 0);

    } catch (e) {
      console.error("Error loading library settings:", e);
    }
  };

  function getTenantCodeFromToken() {
    const token = sessionStorage.getItem("token");
    if (!token) return null;

    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.tenantcode || payload.tenantcode || null;
  }

  const FetchCompany = async () => {
    try {
      const tenantCode = getTenantCodeFromToken();
      if (!tenantCode) {
        return;
      }

      const api = new DataApi("company");
      const resp = await api.fetchAll();

      let companies = [];
      if (resp?.data?.success) {
        companies = resp.data.data || [];
      } else if (Array.isArray(resp?.data)) {
        companies = resp.data;
      }

      const company = companies.find(
        (item) => item.tenantcode === tenantCode
      );

      if (!company) {
        return;
      }

      const bookBankMode =
        company?.book_bank === true || company?.book_bank === 1;

      setCompany(company);
      setCompanybookbank(bookBankMode);
      setBookBankLimit(parseInt(company?.book_bank_books_limit) || 0);

    } catch (e) {
      console.error("Error loading company settings:", e);
    }
  };

  useEffect(() => {
    FetchCompany();
    fetchLibrarySettings();
  }, []);

  useEffect(() => {
    fetchAll();
  }, [refreshTrigger]);

  useEffect(() => {
    if (!issueDate || autoCalculated) return;

    const duration = durationDays;
    const d = new Date(issueDate);
    d.setDate(d.getDate() + duration);

    setDueDate(d.toISOString().split("T")[0]);
    setAutoCalculated(true);
  }, [issueDate, durationDays, autoCalculated]);

  useEffect(() => {
    if (!issueDate || !dueDate) {
      setConfirmDays(0);
      return;
    }

    const start = new Date(issueDate);
    const end = new Date(dueDate);
    const diffTime = end.getTime() - start.getTime();
    const diffDays = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));

    setConfirmDays(diffDays);
  }, [issueDate, dueDate]);

  useEffect(() => {
    if (selectedCard) {
      loadMemberInfo(selectedCard.value);
    } else {
      resetMemberInfo();
    }
  }, [selectedCard, subscriptions, plans, librarySettings, effectiveBookBankMode]);

  useEffect(() => {
    if (selectedCard) {
      setBookPage(0);
      loadBooks(false);
    } else {
      setPaginatedBookCopies([]);
      setBookPage(0);
    }
  }, [bookSearchTerm, manualBookBankMode, selectedCard]);

  useEffect(() => {
    if (!books.length || !bookCopies.length) {
      setFilteredBooksByAge([]);
      setFilteredCopiesByAge([]);
      return;
    }

    let filteredCopies = [];

    if (manualBookBankMode) {
      filteredCopies = bookCopies.filter(
        (copy) => copy.is_book_bank === true || copy.is_book_bank === 1 || copy.is_book_bank === "true"
      );
    } else {
      filteredCopies = bookCopies.filter(
        (copy) => copy.is_book_bank !== true && copy.is_book_bank !== 1 && copy.is_book_bank !== "true"
      );
    }

    const bookIds = new Set(
      filteredCopies.map((c) => c.book_id?.toString())
    );

    const filteredBooks = books.filter((b) =>
      bookIds.has(b.id?.toString())
    );

    setFilteredCopiesByAge(filteredCopies);
    setFilteredBooksByAge(filteredBooks);

  }, [books, bookCopies, manualBookBankMode]);

  const resetMemberInfo = () => {
    setMemberInfo(null);
    setMemberSubscription(null);
    setMemberPlan(null);
    setSubscriptionAllowedBooks(0);
    setMemberPersonalAllowedBooks(0);
    setMemberExtraAllowance(0);
    setMemberAge(null);

    if (effectiveBookBankMode) {
      setTotalAllowedBooks(bookBankLimit);
      setSystemMaxBooks(bookBankLimit);
      setDailyLimitCount(bookBankLimit);
    } else {
      setTotalAllowedBooks(6);
      setSystemMaxBooks(6);
      setDailyLimitCount(2);
    }
  };

  const fetchAll = async () => {
    setLoading(true);
    try {
      const bookApi = new DataApi("book");
      const cardApi = new DataApi("librarycard");
      const userApi = new DataApi("user");
      const issueApi = new DataApi("bookissue");
      const subscriptionApi = new DataApi("subscriptions");
      const planApi = new DataApi("plans");
      const copyApi = new DataApi("book-copy");

      if (fetchIssuedBooks) {
        await fetchIssuedBooks();
      }

      const [
        booksResp,
        cardsResp,
        usersResp,
        issuesResp,
        subscriptionResponse,
        planResponse,
        copiesResp
      ] = await Promise.all([
        bookApi.fetchAll("limit=2000"),
        cardApi.fetchAll(),
        userApi.fetchAll(),
        issueApi.fetchAll(),
        subscriptionApi.fetchAll(),
        planApi.fetchAll(),
        copyApi.fetchAll("limit=2000")
      ]);

      const booksList = normalize(booksResp);
      const cardsList = normalize(cardsResp);
      const usersList = normalize(usersResp);
      const issuesList = normalize(issuesResp);

      let copiesList = [];
      if (copiesResp?.data?.book_copies) {
        copiesList = copiesResp.data.book_copies;
      } else {
        copiesList = normalize(copiesResp);
      }

      let subscriptionsList = [];
      if (subscriptionResponse?.data?.data) {
        subscriptionsList = subscriptionResponse.data.data;
      } else if (subscriptionResponse?.data) {
        subscriptionsList = Array.isArray(subscriptionResponse.data) ?
          subscriptionResponse.data :
          [subscriptionResponse.data];
      } else if (Array.isArray(subscriptionResponse)) {
        subscriptionsList = subscriptionResponse;
      }

      let plansList = [];
      if (planResponse?.data?.data) {
        plansList = planResponse.data.data;
      } else if (planResponse?.data) {
        plansList = Array.isArray(planResponse.data) ?
          planResponse.data :
          [planResponse.data];
      } else if (Array.isArray(planResponse)) {
        plansList = planResponse;
      }

      setBooks(booksList);
      setBookCopies(copiesList);
      setUsers(usersList);
      setSubscriptions(subscriptionsList);
      setPlans(plansList);

      const activeCards = cardsList.filter((c) =>
        c.is_active === true || c.is_active === "true" || c.is_active === 1
      );
      setLibraryCards(activeCards);

      let submissionsList = [];
      try {
        const submissionsResp = await helper.fetchWithAuth(`${constants.API_BASE_URL}/api/book_submissions`, "GET");
        if (submissionsResp.ok) {
          const submissionsData = await submissionsResp.json();
          submissionsList = normalize(submissionsData);
        }
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }

      const allNonReturnedIssues = issuesList.filter(
        (issue) => issue.status !== "returned"
      );

      const transformedSubmissions = submissionsList.map(submission => ({
        id: `submission_${submission.id}`,
        book_id: submission.book_id,
        book_title: submission.book_title,
        book_isbn: submission.book_isbn,
        card_id: submission.card_id || submission.issued_to,
        card_number: submission.card_number,
        issued_to: submission.issued_to,
        issued_to_name: submission.issued_to_name,
        issue_date: submission.issue_date,
        due_date: submission.due_date,
        status: "submitted",
        quantity: 1,
        condition_before: submission.condition_before,
        remarks: submission.remarks,
        submit_date: submission.submit_date,
        penalty: submission.penalty_amount || submission.penalty,
        condition_after: submission.condition_after
      }));

      const combinedBooks = [...allNonReturnedIssues, ...transformedSubmissions];
      setIssuedBooks(combinedBooks);

    } catch (err) {
      console.error("Error fetching lists:", err);
      showErrorToast("Failed to load data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const normalize = (resp) => {
    const data = resp?.data || resp;
    if (Array.isArray(data)) return data;
    if (data?.data && Array.isArray(data.data)) return data.data;
    if (data?.book_copies && Array.isArray(data.book_copies)) return data.book_copies;
    if (typeof data === 'object' && data !== null) {
      for (const key in data) {
        if (Array.isArray(data[key])) return data[key];
      }
    }
    return [];
  };

  const fetchBookCopiesBatch = async (page = 0, search = '', isBookBank = false, minAge = null) => {
    const copyApi = new DataApi("book-copy");
    const limit = 20;
    const currentPage = page + 1; 
    
    const params = new URLSearchParams({
      limit: limit.toString(),
      page: currentPage.toString()
    });

    if (search.trim()) {
      params.append('search', search.trim());
    }
    
    params.append('is_book_bank', isBookBank ? '1' : '0');

    if (minAge !== null) {
      params.append('min_age', minAge.toString());
    }

    const resp = await copyApi.fetchAll(params.toString());
    const newCopies = normalize(resp);

    return { copies: newCopies, hasMore: newCopies.length === limit };
  };

  const loadBooks = async (append = false) => {
    const reqId = ++requestRef.current;

    try {
      if (!append) {
        setBookLoading(true);
      } else {
        if (bookLoadingMore) return; 
        setBookLoadingMore(true);
      }

      const isBookBank = manualBookBankMode;
      const minAge = memberAge !== null ? memberAge : null;
      const pageToFetch = append ? bookPage : 0;

      const { copies, hasMore } = await fetchBookCopiesBatch(
        pageToFetch,
        bookSearchTerm,
        isBookBank,
        minAge
      );

      if (reqId !== requestRef.current) return;

      setPaginatedBookCopies(prev => (append ? [...prev, ...copies] : copies));
      setBookHasMore(hasMore);
      setBookPage(pageToFetch + 1);

    } catch (error) {
      console.error('Error loading book copies:', error);
      if (reqId === requestRef.current) {
        showErrorToast('Failed to load books. Please try again.');
      }
    } finally {
      if (reqId === requestRef.current) {
        setBookLoading(false);
        setBookLoadingMore(false);
      }
    }
  };

  const handleSearchInputChange = (term) => {
    setSelectInputValue(term);
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      setBookSearchTerm(term);
    }, 300);
  };

  const clearSearch = () => {
    setSelectInputValue('');
    setBookSearchTerm('');
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
  };

  const loadMemberInfo = async (cardId) => {
    try {
      const cardApi = new DataApi("librarycard");
      const memberResp = await cardApi.fetchById(cardId);

      if (memberResp && memberResp.data) {
        const member = memberResp.data;
        setMemberInfo(member);

        const memberDob = member.dob || member.date_of_birth || member.birth_date;
        let age = null;

        if (memberDob) {
          age = calculateMemberAge(memberDob);
          setMemberAge(age);
        } else {
          setMemberAge(null);
        }

        if (effectiveBookBankMode) {
          setTotalAllowedBooks(bookBankLimit);
          setSystemMaxBooks(bookBankLimit);
          setMemberExtraAllowance(0);
          setDailyLimitCount(bookBankLimit);
          return;
        }

        let personalAllowed = 0;
        if (member.allowed_books !== undefined && member.allowed_books !== null) {
          personalAllowed = parseInt(member.allowed_books);
        } else if (member.allowedBooks !== undefined && member.allowedBooks !== null) {
          personalAllowed = parseInt(member.allowedBooks);
        } else if (member.allowed !== undefined && member.allowed !== null) {
          personalAllowed = parseInt(member.allowed);
        }

        if (isNaN(personalAllowed) || personalAllowed < 0) {
          personalAllowed = 0;
        }

        setMemberPersonalAllowedBooks(personalAllowed);
        setMemberExtraAllowance(personalAllowed);

        let planId = null;
        if (member.plan_id) {
          planId = member.plan_id;
        } else if (member.planId) {
          planId = member.planId;
        }

        let subscription = null;
        let plan = null;
        let subscriptionBooks = 0;
        let planDuration = 0;
        let dailyLimit = 2;

        if (planId && plans.length > 0) {
          plan = plans.find(p => {
            return (
              p.id?.toString() === planId.toString() ||
              p._id?.toString() === planId.toString()
            );
          });

          if (plan) {
            subscriptionBooks = parseInt(plan.allowed_books || 0);
            if (isNaN(subscriptionBooks) || subscriptionBooks < 0) {
              subscriptionBooks = 0;
            }
            if (plan.duration_days) {
              planDuration = parseInt(plan.duration_days);
            }

            if (plan.max_allowed_books_at_time !== undefined && plan.max_allowed_books_at_time !== null) {
              dailyLimit = parseInt(plan.max_allowed_books_at_time);
              if (isNaN(dailyLimit) || dailyLimit < 1) {
                dailyLimit = 2;
              }
            } else {
              dailyLimit = 2;
            }

            const isPlanActive = plan.is_active === true ||
              plan.is_active === "true" ||
              plan.is_active === 1;

            if (!isPlanActive) {
              subscriptionBooks = 0;
            }
          }
        }

        if (!plan && subscriptions.length > 0) {
          let subscriptionId = null;
          if (member.subscription_id) {
            subscriptionId = member.subscription_id;
          } else if (member.subscriptionId) {
            subscriptionId = member.subscriptionId;
          } else if (member.subscription) {
            subscriptionId = member.subscription;
          }

          if (subscriptionId) {
            subscription = subscriptions.find(sub => {
              return (
                sub.id?.toString() === subscriptionId.toString() ||
                sub._id?.toString() === subscriptionId.toString() ||
                sub.plan_id?.toString() === subscriptionId.toString() ||
                sub.planId?.toString() === subscriptionId.toString()
              );
            });

            if (subscription) {
              subscriptionBooks = parseInt(subscription.allowed_books || 0);
              if (isNaN(subscriptionBooks) || subscriptionBooks < 0) {
                subscriptionBooks = 0;
              }

              if (subscription.duration_days) {
                planDuration = parseInt(subscription.duration_days);
              } else if (subscription.duration) {
                planDuration = parseInt(subscription.duration);
              }

              if (subscription.max_allowed_books_at_time !== undefined && subscription.max_allowed_books_at_time !== null) {
                dailyLimit = parseInt(subscription.max_allowed_books_at_time);
              } else if (subscription.maxBooksAtTime !== undefined && subscription.maxBooksAtTime !== null) {
                dailyLimit = parseInt(subscription.maxBooksAtTime);
              } else if (subscription.max_at_time !== undefined && subscription.max_at_time !== null) {
                dailyLimit = parseInt(subscription.max_at_time);
              } else if (subscription.daily_limit !== undefined && subscription.daily_limit !== null) {
                dailyLimit = parseInt(subscription.daily_limit);
              }

              if (isNaN(dailyLimit) || dailyLimit < 1) {
                dailyLimit = 2;
              }

              const isSubscriptionActive = subscription.is_active === true ||
                subscription.is_active === "true" ||
                subscription.is_active === 1 ||
                subscription.status === "active";

              if (!isSubscriptionActive) {
                subscriptionBooks = 0;
              }
            }
          }
        }

        setMemberPlan(plan);
        setMemberSubscription(subscription);
        setSubscriptionAllowedBooks(subscriptionBooks);
        setDurationDays(planDuration);
        setDailyLimitCount(dailyLimit);

        const d = new Date(issueDate);
        d.setDate(d.getDate() + planDuration);
        setDueDate(d.toISOString().split("T")[0]);
        setAutoCalculated(true);

        const systemMax = subscriptionBooks > 0 ? subscriptionBooks : 6;
        setSystemMaxBooks(systemMax);

        let totalAllowed = systemMax;
        if (personalAllowed > 0) {
          totalAllowed += personalAllowed;
        }

        setTotalAllowedBooks(totalAllowed);

      } else {
        console.warn("No member data found for card:", cardId);
        resetMemberInfo();
      }
    } catch (err) {
      console.error("Error loading member info:", err);
      resetMemberInfo();
    }
  };

  const calculateMemberAge = (dobString) => {
    if (!dobString) return null;
    const dob = new Date(dobString);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };

  const findUserByCardId = (cardId) => {
    if (!cardId) return null;
    const card = libraryCards.find(c => c.id.toString() === cardId.toString()); 
    if (!card) return null;
    const userId = card.user_id || card.userId;
    if (userId) {
      return users.find(u => u.id.toString() === userId.toString());
    }
    if (card.user_name || card.student_name) {
      return {
        name: card.user_name || card.student_name,
        email: card.email || 'N/A',
        phone: card.phone || 'N/A'
      };
    }
    return null;
  };

  const computeIssuedCountForCard = (cardId) => {
    if (!cardId) return 0;
    return issuedBooks.filter(
      (i) => {
        const issCardId = i.card_id || i.cardId || i.library_card_id;
        return issCardId?.toString() === cardId.toString() && i.status === "issued";
      }
    ).length;
  };

  const computeIssuedTodayForCard = (cardId) => {
    if (!cardId || effectiveBookBankMode) return 0;

    const today = new Date();
    return issuedBooks.filter((i) => {
      const issCardId = i.card_id || i.cardId || i.library_card_id;
      const issueDate = i.issue_date || i.issueDate;
      if (!issueDate) return false;
      const issue = new Date(issueDate);
      
      const isBookBank = i.is_book_bank === true || i.is_book_bank === 1 || i.is_book_bank === "true";

      return (
        issCardId?.toString() === cardId.toString() &&
        !isBookBank &&
        issue.getFullYear() === today.getFullYear() &&
        issue.getMonth() === today.getMonth() &&
        issue.getDate() === today.getDate()
      );
    }).length;
  };

  const isBookIssuedToSelectedCard = (bookId, bookTitle, copyId) => {
    if (!selectedCard) return false;

    const cardVal = selectedCard.value.toString();

    return issuedBooks.some((iss) => {
      const issCardId = iss.card_id || iss.cardId || iss.library_card_id || iss.issued_to;
      if (issCardId?.toString() !== cardVal) return false;

      if (iss.status?.toLowerCase() !== "issued") return false;

      const issBookId = iss.book_id || iss.bookId || iss.book?.id || iss.book_details?.id;
      if (issBookId && bookId && issBookId.toString() === bookId.toString()) {
        return true;
      }

      const issCopyId = iss.book_copy_id || iss.copy_id || iss.copyId;
      if (issCopyId && copyId && issCopyId.toString() === copyId.toString()) {
        return true;
      }

      const issTitle = iss.book_title || iss.title || iss.book?.title || iss.book_details?.title;
      if (issTitle && bookTitle && issTitle.trim().toLowerCase() === bookTitle.trim().toLowerCase()) {
        return true;
      }


      return false;
    });
  };

  const showSuccessToast = (message) => {
    PubSub.publish("RECORD_SUCCESS_TOAST", {
      title: "Success",
      message: message,
    });
  };

  const showErrorToast = (message) => {
    PubSub.publish("RECORD_ERROR_TOAST", {
      title: "Error",
      message: message,
    });
  };

  const showWarningToast = (message) => {
    PubSub.publish("RECORD_WARNING_TOAST", {
      title: "Warning",
      message: message,
    });
  };

  const validateIssuance = () => {
    if (!selectedCard) {
      showErrorToast("Please select a library card first.");
      return false;
    }

    if (selectedBooks.length === 0) {
      showErrorToast("Please select at least one book to issue.");
      return false;
    }

    if (effectiveBookBankMode) {
      if (bookBankLimit === 0) {
        showErrorToast("Book bank limit is not configured in library settings.");
        return false;
      }

      const issuedCount = getIssuedCountForMode();
      const toIssueCount = selectedBooks.length;

      if (issuedCount + toIssueCount > bookBankLimit) {
        showErrorToast(
          `Book bank limit is ${bookBankLimit} books. ` +
          `Already issued: ${issuedCount}, Trying to issue: ${toIssueCount}. ` +
          `Available: ${Math.max(0, bookBankLimit - issuedCount)}`
        );
        return false;
      }

      return true;
    }

    if (selectedBooks.length > dailyLimitCount) {
      showErrorToast(
        `Daily limit is ${dailyLimitCount} books per day. ` +
        `Currently selected: ${selectedBooks.length} books.`
      );
      return false;
    }

    const issuedTodayCount = computeIssuedTodayForCard(selectedCard.value);
    const availableToday = Math.max(0, dailyLimitCount - issuedTodayCount);

    if (selectedBooks.length > availableToday) {
      showErrorToast(
        `Daily limit is ${dailyLimitCount} books. ` +
        `Already issued today: ${issuedTodayCount}, ` +
        `Trying to issue: ${selectedBooks.length}. ` +
        `Available for today: ${availableToday}`
      );
      return false;
    }

    const bookIds = selectedBooks.map(b => b.value);
    const uniqueBookIds = [...new Set(bookIds)];
    if (bookIds.length !== uniqueBookIds.length) {
      showWarningToast("You have selected the same book multiple times. Please select only one copy of each book.");
      return false;
    }

    const issuedCount = getIssuedCountForMode();
    const toIssueCount = selectedBooks.length;

    if (issuedCount + toIssueCount > totalAllowedBooks) {
      showErrorToast(
        `Maximum ${totalAllowedBooks} books allowed for this member. ` +
        `Already issued: ${issuedCount}, Trying to issue: ${toIssueCount}. ` +
        `(Plan max: ${systemMaxBooks} + Extra allowance: ${memberExtraAllowance})`
      );
      return false;
    }

    const unavailableBooks = [];
    selectedBooks.forEach(book => {
      const status = book.data.copyStatus || 'AVAILABLE';
      if (status.toUpperCase() !== 'AVAILABLE') {
        unavailableBooks.push(book.data.title);
      }
    });

    if (unavailableBooks.length > 0) {
      showErrorToast(
        `The following selected books are not currently available: ${unavailableBooks.join(", ")}`
      );
      return false;
    }

    if (memberInfo && memberInfo.is_active !== undefined && !memberInfo.is_active) {
      showErrorToast("This library member is inactive. Please select an active member.");
      return false;
    }

    return true;
  };

  const handleIssue = async () => {
    if (!validateIssuance()) return;

    setProcessing(true);
    try {
      const successBooks = [];
      const failedBooks = [];
      const memberName = memberInfo
        ? `${memberInfo.first_name || ''} ${memberInfo.last_name || ''}`.trim()
        : "Unknown Member";

      for (const b of selectedBooks) {
        try {
          const body = {
            book_id: b.value,
            book_copy_id: b.copy_id || (selectedCopies[b.value]?.id || null),
            card_id: selectedCard.value,
            issue_date: issueDate,
            due_date: dueDate,
            condition_before: "Good",
            remarks: "",
            is_book_bank: effectiveBookBankMode,
          };
          
          const response = await helper.fetchWithAuth(
            `${constants.API_BASE_URL}/api/bookissue/issue`,
            "POST",
            body
          );

          const result = await response.json();

          if (response.ok && result.success) {
            successBooks.push({
              title: b.data.title,
              data: result.data,
            });
          } else {
            const errorMessage = extractErrorMessage(result);
            failedBooks.push({
              book: b.data.title,
              error: errorMessage,
              details: result.details || {},
            });
          }
        } catch (bookErr) {
          failedBooks.push({
            book: b.data.title,
            error: `Network error: ${bookErr.message}`,
            details: { network_error: bookErr.message },
          });
        }
      }

      if (successBooks.length > 0) {
        const successTitles = successBooks.map(b => b.title);
        const newIssuedCount = getIssuedCountForMode() + successBooks.length;
        const limit = effectiveBookBankMode ? bookBankLimit : totalAllowedBooks;
        const remaining = Math.max(0, limit - newIssuedCount);

        let message = `Successfully issued ${successBooks.length} book(s) to ${memberName}: ${successTitles.join(", ")}. Remaining allowed: ${remaining}.`;

        if (!effectiveBookBankMode) {
          const issuedToday = computeIssuedTodayForCard(selectedCard.value) + successBooks.length;
          const remainingToday = Math.max(0, dailyLimitCount - issuedToday);

          message += ` Daily limit: ${issuedToday}/${dailyLimitCount} (${remainingToday} remaining today).`;
        }

        showSuccessToast(message);
      }

      if (failedBooks.length > 0) {
        failedBooks.forEach(failed => {
          showErrorToast(`${failed.book}: ${failed.error}`);
        });
      }

      if (failedBooks.length === 0) {
        setSelectedBooks([]);
        setSelectedCopies({});
        if (fetchIssuedBooks) {
          await fetchIssuedBooks(); 
        }
        setRefreshTrigger(prev => prev + 1);

      } else {
        const remainingBooks = selectedBooks.filter(book =>
          !successBooks.some(success => success.title === book.data.title)
        );
        const newCopies = { ...selectedCopies };
        successBooks.forEach(s => {
          const found = selectedBooks.find(b => b.data.title === s.title);
          if (found) delete newCopies[found.value];
        });
        setSelectedCopies(newCopies);
        setSelectedBooks(remainingBooks);
        setRefreshTrigger(prev => prev + 1);
      }
    } catch (err) {
      console.error("Bulk issue error:", err);
      showErrorToast(err.message || "Failed to issue books. Please try again.");
    } finally {
      setProcessing(false);
    }
  };

  const extractErrorMessage = (result) => {
    if (!result) return "Unknown error";
    if (result.message) return result.message;
    if (result.error) return result.error;
    if (result.errors && Array.isArray(result.errors)) {
      return result.errors.map(err => {
        if (typeof err === 'string') return err;
        if (err.msg) return err.msg;
        if (err.message) return err.message;
        return JSON.stringify(err);
      }).join(", ");
    }
    return "Unknown error occurred";
  };

  const issuedCountForSelectedCard = selectedCard
    ? computeIssuedCountForCard(selectedCard.value)
    : 0;

  const bookBankIssuedCountForSelectedCard = selectedCard ? issuedBooks.filter(i => {
    const issCardId = i.card_id || i.cardId || i.library_card_id;
    const isBookBank = i.is_book_bank === true || i.is_book_bank === 1 || i.is_book_bank === "true";
    return issCardId?.toString() === selectedCard.value.toString() && isBookBank && i.status === "issued";
  }).length : 0;

  const regularIssuedCountForSelectedCard = issuedCountForSelectedCard - bookBankIssuedCountForSelectedCard;

  const issuedTodayForSelectedCard = selectedCard
    ? computeIssuedTodayForCard(selectedCard.value)
    : 0;

  const remainingForCard = Math.max(
    0,
    totalAllowedBooks - issuedCountForSelectedCard
  );

  const remainingForToday = effectiveBookBankMode
    ? remainingForCard
    : Math.max(0, dailyLimitCount - issuedTodayForSelectedCard);

  const getIssuedCountForMode = () => effectiveBookBankMode ? bookBankIssuedCountForSelectedCard : regularIssuedCountForSelectedCard;

  const getProgressPercent = () => {
    const count = getIssuedCountForMode();
    const limit = effectiveBookBankMode ? bookBankLimit : totalAllowedBooks;
    return limit > 0 ? Math.round((count / limit) * 100) : 0;
  };

  const getModeLimit = () => effectiveBookBankMode ? bookBankLimit : totalAllowedBooks;

  const getRemainingForMode = () => {
    const count = getIssuedCountForMode();
    const limit = getModeLimit();
    return Math.max(0, limit - count);
  };

  const maxAllowedToSelect = effectiveBookBankMode 
    ? getRemainingForMode() 
    : Math.min(getRemainingForMode(), Math.max(0, dailyLimitCount - issuedTodayForSelectedCard));

  const getIssuedBooksForSelectedCard = () => {
    if (!selectedCard) return [];
    return issuedBooks.filter((i) => {
      const issCardId = i.card_id || i.cardId || i.library_card_id;
      const isCardMatch = issCardId?.toString() === selectedCard.value.toString();
      
      const isBookBankIssue = i.is_book_bank === true || i.is_book_bank === 1 || i.is_book_bank === "true";

      if (effectiveBookBankMode) {
        return isCardMatch && isBookBankIssue;
      } else {
        return isCardMatch && !isBookBankIssue;
      }
    });
  };

  const cardOptions = libraryCards.map((c) => {
    const getFullName = () => {
      if (c.first_name || c.last_name) {
        return `${c.first_name || ''} ${c.last_name || ''}`.trim();
      } else if (c.user_name) {
        return c.user_name;
      } else if (c.student_name) {
        return c.student_name;
      } else if (c.name) {
        return c.name;
      }
      return "Unknown Member";
    };

    const fullName = getFullName();
    const cardNumber = c.card_number || "No Card Number";

    return {
      value: c.id,
      label: `${cardNumber} - ${fullName}`,
      subLabel: `Email: ${c.email || 'N/A'} | Phone: ${c.phone_number || 'N/A'}`,
      data: c,
    };
  });

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: "#dee2e6",
      boxShadow: "none",
      "&:hover": { borderColor: "#8b5cf6" },
      padding: "4px",
      zIndex: 1,
      backgroundColor: state.isDisabled ? "#f3f4f6" : "white" 
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      position: "absolute",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "var(--primary-color)"
        : state.isFocused
          ? "#f3f0ff"
          : "white",
      color: state.isDisabled ? "#999" : "inherit",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
    }),
  };

  const getImageUrl = (image) => {
    if (!image) return "/default-avatar.png";
    if (image.startsWith("http")) {
      return image;
    }
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3003"
        : process.env.REACT_APP_API_URL;
    return `${baseUrl}${image}`;
  };

  const getMemberName = () => {
    if (!selectedCard) return "Unknown";
    if (memberInfo) {
      return `${memberInfo.first_name || ''} ${memberInfo.last_name || ''}`.trim() ||
        memberInfo.user_name ||
        memberInfo.student_name ||
        "Unknown Member";
    }
    const user = findUserByCardId(selectedCard.value);
    return user ? (user.name || user.full_name || user.username) :
      (selectedCard.data.user_name || selectedCard.data.student_name || "Unknown User");
  };

  const getMemberAge = () => {
    let dob = null;
    if (memberInfo) {
      dob = memberInfo.dob || memberInfo.date_of_birth;
    } else {
      const user = findUserByCardId(selectedCard?.value);
      dob = user?.dob || user?.date_of_birth || selectedCard?.data?.dob;
    }
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const getMemberInitial = () => {
    const name = getMemberName();
    return name?.charAt(0).toUpperCase() || "?";
  };

  const bookSelectOptions = paginatedBookCopies
    .filter((copy) => {
      const isCopyBB = copy.is_book_bank === true || copy.is_book_bank === 1 || copy.is_book_bank === "1" || copy.is_book_bank === "true";
      const modeMatch = manualBookBankMode ? isCopyBB : !isCopyBB;
      
      const book = books.find(b => b.id?.toString() === copy.book_id?.toString()) || {};
      const title = copy.title || book.title || 'Unknown Title';

      const isAlreadyIssuedToMember = isBookIssuedToSelectedCard(copy.book_id, title, copy.id);

      return modeMatch && !isAlreadyIssuedToMember;
    })
    .map((copy) => {
      const book = books.find(b => b.id?.toString() === copy.book_id?.toString()) || {};
      const title = copy.title || book.title || 'Unknown Title';
      const isAvailable = copy.status?.toUpperCase() === 'AVAILABLE';

       let label = `${title}`;
      // let label = `[${copy.barcode}] ${title}`;
      if (copy.itemcallnumber) label += ` | ${callNumberLabel || "Call Number"} : ${copy.itemcallnumber}`;


      // let label = copy.barcode ? `${copy.barcode} - ` : '';
      // label += title;
      if (copy.itemcallnumber) label += ` | Call#: ${copy.itemcallnumber}`;
      if (copy.full_location_code) label += ` | Rack: ${copy.full_location_code}`;

      if (!isAvailable) label += ` (${copy.status || 'Unavailable'})`;

      return {
        value: copy.book_id,
        copy_id: copy.id,
        label: label, 
        isDisabled: !isAvailable,
        copyData: copy,
        bookData: book,
        data: {
           ...book,
           copy_id: copy.id,
           copyStatus: copy.status || 'UNAVAILABLE',
           title: title,
           barcode: copy.barcode,
           itemcallnumber: copy.itemcallnumber,
           isbn: copy.isbn || book.isbn,
           author_name: copy.author_name || book.author_name,
           min_age: book.min_age,
           full_location_code: copy.full_location_code 
        }
      };
    });

  const handleDropdownBookChange = (selectedOptions) => {
    const selected = selectedOptions || [];
    
    if (selected.length > maxAllowedToSelect) {
      showErrorToast(`Maximum limit reached. You can only select ${maxAllowedToSelect} book(s) right now.`);
      return; 
    }

    setSelectedBooks(selected);

    const newSelectedCopies = {};
    selected.forEach(opt => {
      if (opt.copyData) {
        newSelectedCopies[opt.value] = opt.copyData;
      } else if (selectedCopies[opt.value]) {
        newSelectedCopies[opt.value] = selectedCopies[opt.value];
      }
    });
    setSelectedCopies(newSelectedCopies);
  };


  return (
    <Container
      fluid
      className="p-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row>
          <Col lg={4} md={5} className="mb-4">
            <Card
              className="shadow-sm border-0 mb-4"
              style={{ borderRadius: "16px" }}
            >
              <Card.Body className="p-4">
                <h6 className="fw-bold text-uppercase text-muted small mb-3">
                  Step 1: Select Member
                </h6>
                <Select
                  options={cardOptions}
                  value={selectedCard}
                  onChange={(v) => {
                    setSelectedCard(v);
                    setSelectedBooks([]);
                    resetMemberInfo();
                  }}
                  isClearable
                  placeholder="Search by card number, name, email..."
                  styles={customSelectStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  formatOptionLabel={({ label, subLabel, data }) => {
                    const parts = label.split(' - ');
                    const cardNumber = parts[0] || 'N/A';
                    const memberName = parts.slice(1).join(' - ') || 'Unknown Member';

                    return (
                      <div className="d-flex flex-column">
                        <div className="d-flex align-items-center">
                          <Badge
                            bg="primary"
                            className="me-2 px-2 py-1"
                            style={{
                              minWidth: '90px',
                              fontSize: '0.55rem',
                              fontWeight: 'bold'
                            }}
                          >
                            <i className="fa-solid fa-id-card me-1"></i>
                            {cardNumber}
                          </Badge>

                          <div className="fw-bold" style={{ flex: 1 }}>
                            {memberName}
                          </div>
                        </div>
                      </div>
                    );
                  }}
                />
              </Card.Body>
            </Card>

            <Card
              className="shadow-sm border-0"
              style={{
                borderRadius: "16px",
                background: selectedCard ? "white" : "#f1f3f5",
                opacity: selectedCard ? 1 : 0.7,
              }}
            >
              <Card.Body className="p-4">
                {!selectedCard ? (
                  <div className="py-4 text-muted text-center">
                    <i className="fa-solid fa-id-card fa-3x mb-3 text-secondary"></i>
                    <p className="mb-0">Select a card above to view member details</p>
                  </div>
                ) : (
                  <>
                    <div className="text-center mb-3">
                      <div className="mb-2">
                        <div className="text-center mb-3">
                          <div className="mb-2">
                            <div
                              className="rounded-circle d-flex justify-content-center align-items-center mx-auto position-relative overflow-hidden"
                              style={{
                                width: "80px",
                                height: "80px",
                                border: "3px solid #8b5cf6",
                                backgroundColor: "#e9ecef"
                              }}
                            >
                              {memberInfo?.image ? (
                                <img
                                  src={memberInfo.image}
                                  alt={getMemberName()}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    position: "absolute",
                                    top: 0,
                                    left: 0
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "#8b5cf6",
                                    fontSize: "2.5rem",
                                    fontWeight: "bold",
                                    backgroundColor: "#e9ecef"
                                  }}
                                >
                                  {getMemberInitial()}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <h5 className="fw-bold mb-1">{getMemberName()}</h5>
                      {!effectiveBookBankMode && (
                        <span className="fw-bold mb-1"> Age : {getMemberAge()}</span>
                      )}
                    </div>

                    <Row className="g-2 mb-3">
                      <Col xs={4}>
                        <div className="b-none bg-light rounded-3">
                          <Button
                            variant=""
                            size="sm"
                            onClick={() => setShowIssuedBooks(!showIssuedBooks)}
                            className="mb-2"
                          >
                            <div className="small text-muted">
                              Issued Books
                            </div>
                            <div className="h5 mb-0 fw-bold text-dark">
                              {getIssuedCountForMode()}
                            </div>
                          </Button>
                        </div>
                      </Col>

                      {!effectiveBookBankMode && (
                        <Col xs={4}>
                          <div className="p-2 bg-light rounded-3">
                            <div className="small text-muted">Issued Today</div>
                            <div className="h5 mb-0 fw-bold text-dark">
                              {issuedTodayForSelectedCard}/{dailyLimitCount}
                            </div>
                          </div>
                        </Col>
                      )}

                      <Col xs={4}>
                        <div className="p-2 bg-light rounded-3">
                          <div className="small text-muted">
                            {effectiveBookBankMode ? 'Bank Limit' : 'Total Allowed'}
                          </div>
                          <div className="h5 mb-0 fw-bold text-dark">
                            {getModeLimit()}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {showIssuedBooks && (
                        <div className="mt-3 rounded">
                          <Table striped bordered hover size="sm">
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Quantity</th>
                                <th>ISBN/ISSN</th>
                                <th>Book Bank</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {getIssuedBooksForSelectedCard().map((issue, index) => {
                                let callNumber = 'N/A';

                                if (issue.book_callnumber) callNumber = issue.book_callnumber;
                                else if (issue.callnumber) callNumber = issue.callnumber;
                                else if (issue.itemcallnumber) callNumber = issue.itemcallnumber;
                                else if (issue.call_number) callNumber = issue.call_number;
                                else if (issue.call_no) callNumber = issue.call_no;
                                else if (issue.book?.callnumber) callNumber = issue.book.callnumber;
                                else if (issue.book?.itemcallnumber) callNumber = issue.book.itemcallnumber;
                                else if (issue.book_details?.callnumber) callNumber = issue.book_details.callnumber;
                                else if (issue.book_details?.itemcallnumber) callNumber = issue.book_details.itemcallnumber;
                                else {
                                  const bookId = issue.book_id || issue.bookId;
                                  if (bookId && bookCopies.length > 0) {
                                    const foundBook = bookCopies.find(b =>
                                      b.id?.toString() === bookId.toString() ||
                                      b.book_id?.toString() === bookId.toString()
                                    );
                                    if (foundBook?.itemcallnumber) callNumber = foundBook.itemcallnumber;
                                  }
                                }

                                const title = issue.book_title ||
                                  issue.title ||
                                  issue.book?.title ||
                                  issue.book_details?.title ||
                                  'Unknown Book';

                                const isbn = issue.book_isbn ||
                                  issue.isbn ||
                                  issue.book?.isbn ||
                                  issue.book_details?.isbn ||
                                  'N/A';

                                const quantity = issue.quantity || issue.qty || 1;

                                return (
                                  <tr key={index}>
                                    <td>
                                      <div>
                                        <strong>{title}</strong>
                                        {title === 'Unknown Book' && (
                                          <small className="text-muted d-block">
                                            Book ID: {issue.book_id || issue.bookId || 'N/A'}
                                          </small>
                                        )}
                                      </div>
                                    </td>
                                    <td>{quantity}</td>
                                    <td>{isbn}</td>
                                    <td>
                                      {Boolean(issue.is_book_bank) ? (
                                        <Badge bg="success">Yes</Badge>
                                      ) : (
                                        <Badge bg="danger">No</Badge>
                                      )}
                                    </td>
                                    <td>
                                      {issue.status === "issued" ? (
                                        <Badge bg="success">Issued</Badge>
                                      ) : issue.status === "submitted" ? (
                                        <Badge bg="secondary">Submitted</Badge>
                                      ) : issue.status === "returned" ? (
                                        <Badge bg="info">Returned</Badge>
                                      ) : (
                                        <Badge bg="danger">Cancelled</Badge>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}

                              {getIssuedBooksForSelectedCard().length === 0 && (
                                <tr>
                                  <td colSpan="5" className="text-center text-muted py-3">
                                    No books issued for this mode
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>

                    <div className="text-start mt-3">
                      <div className="d-flex justify-content-between small mb-1">
                        <span className="fw-bold" style={{ color: effectiveBookBankMode ? '#10b981' : '#3b82f6' }}>
                          {effectiveBookBankMode ? 'Book Bank Usage' : 'Regular Usage'}
                        </span>
                        <span>
                          {getProgressPercent()}%
                        </span>
                      </div>
                      <ProgressBar
                        now={getProgressPercent()}
                        variant={
                          getRemainingForMode() === 0 ? "danger" :
                            getRemainingForMode() <= 2 ? "warning" : "primary"
                        }
                        style={{ height: "10px", borderRadius: "10px" }}
                      />
                      <div className="small text-muted mt-1">
                        <div className="d-flex justify-content-between">
                          <span>
                            {getIssuedCountForMode()} / {getModeLimit()} {effectiveBookBankMode ? 'book bank' : 'books'}
                          </span>
                        </div>
                      </div>
                    </div>

                    {!effectiveBookBankMode && selectedCard && remainingForToday === 0 && remainingForCard > 0 && (
                      <Alert variant="warning" className="mt-3 small p-2">
                        <i className="fa-solid fa-triangle-exclamation me-1"></i>
                        Daily limit reached! Can issue {remainingForCard} more books tomorrow.
                      </Alert>
                    )}

                    {memberInfo && !memberInfo.is_active && (
                      <Alert variant="danger" className="mt-3 small p-2">
                        <i className="fa-solid fa-triangle-exclamation me-1"></i>
                        This member is inactive and cannot issue books.
                      </Alert>
                    )}
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col lg={8} md={7}>
            <Card
              className="shadow-sm border-0"
              style={{ borderRadius: "16px", height: "100%" }}
            >         
              <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold text-uppercase text-muted small mb-0">
                    Step 2: Select Books
                  </h6>
                  {selectedBooks.length > 0 && (
                    <Badge bg="primary" pill>
                      {selectedBooks.length} Selected
                    </Badge>
                  )}
                </div>

                <div className="mb-3 p-3 bg-light rounded">
                  <Form.Switch
                    id="bookBankModeToggle"
                    label={
                      <div className="d-flex align-items-center">
                        <span className="fw-bold me-2">Show Book Bank</span>
                      </div>
                    }
                    checked={manualBookBankMode}
                    onChange={(e) => {
                      setManualBookBankMode(e.target.checked);
                      setSelectedBooks([]);
                      if (selectedCard) {
                        loadMemberInfo(selectedCard.value);
                      }
                    }}
                  />
                  <small className="text-muted ms-4">
                    {manualBookBankMode ? 'Only showing Book Bank copies' : 'Showing all copies except Book Bank'}
                  </small>
                </div>

                <div className="mb-4">
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold small text-muted">
                      Search & Select Books <Badge bg="info">{bookSelectOptions.length} Loaded</Badge>
                    </Form.Label>
                    
                    {/* UPDATED: React Select Component */}
                    <Select
                      isMulti
                      options={bookSelectOptions}
                      value={selectedBooks}
                      inputValue={selectInputValue}
                      onInputChange={(inputValue, { action }) => {
                        if (action === 'input-change') {
                          handleSearchInputChange(inputValue);
                        }
                      }}
                      onChange={(selectedOptions, { action }) => {
                        handleDropdownBookChange(selectedOptions);
                        if (action === 'select-option' || action === 'remove-value' || action === 'clear') {
                          clearSearch();
                        }
                      }}
                      onMenuScrollToBottom={() => {
                        if (bookHasMore && !bookLoadingMore && !bookLoading) {
                          loadBooks(true); 
                        }
                      }}
                      isLoading={bookLoading || bookLoadingMore}
                      placeholder={
                        !selectedCard 
                          ? `Search by title or ${callNumberLabel}...`
                          : selectedBooks.length >= maxAllowedToSelect
                            ? "Maximum allowed books selected"
                            : `Search or scan barcode... (${selectedBooks.length}/${maxAllowedToSelect} allowed)`
                            
                      }
                      isDisabled={!selectedCard || selectedBooks.length >= maxAllowedToSelect}
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      filterOption={null}
                      controlShouldRenderValue={false} 
                      noOptionsMessage={() => (bookLoading ? "Loading..." : "No available books found")}
                      formatOptionLabel={(option, { context }) => {
                        if (context === 'value') return option.label;

                        const { barcode, title, itemcallnumber, min_age, full_location_code } = option.data || {};
                        const status = option.data?.copyStatus || 'UNAVAILABLE';
                        const isAvail = status.toUpperCase() === 'AVAILABLE';

                        return (
                          <div className="d-flex flex-column w-100" style={{ padding: '4px 0', opacity: isAvail ? 1 : 0.6 }}>
                            <div className="text-dark mb-2" style={{ fontSize: '14px', whiteSpace: 'normal', lineHeight: '1.4' }}>
                              {barcode ? `${barcode} - ` : ''}{title}
                              {itemcallnumber ? <span className="text-muted"> | {callNumberLabel || "Call Number"}: {itemcallnumber}</span> : ''}
                            </div>
                            <div className="d-flex align-items-center mt-1 flex-wrap gap-3" style={{ fontSize: '13px', color: '#4b5563' }}>
                              <div className="d-flex align-items-center">
                                <i className="fa-solid fa-user-group me-2" style={{ fontSize: '12px' }}></i> Age: {min_age || 0}+ years
                              </div>
                              <div className="d-flex flex-wrap gap-2">
                                <span 
                                  className="badge rounded-pill px-3 py-2" 
                                  style={{ 
                                    backgroundColor: isAvail ? '#e0f2fe' : '#fee2e2', 
                                    color: isAvail ? '#0369a1' : '#991b1b', 
                                    fontWeight: '600' 
                                  }}
                                >
                                  {status.toUpperCase()}
                                </span>
                                <span className="badge rounded-pill px-3 py-2" style={{ backgroundColor: '#f3f4f6', color: '#374151', fontWeight: '500' }}>
                                  Barcode: {barcode || 'N/A'} | Rack: {full_location_code || 'N/A'}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      }}
                    />
                  </Form.Group>

                  <div className="mt-2 small text-muted">
                    Selected: {selectedBooks.length}/{maxAllowedToSelect} allowed right now | 
                    {!bookHasMore ? ' All matching books loaded' : ` Scroll dropdown menu to load more (Page ${bookPage})`}
                  </div>
                </div>

                <div className="mb-4">
                  {selectedBooks.length === 0 ? (
                    <div
                      className="text-center p-5 border rounded-3"
                      style={{
                        borderStyle: "dashed",
                        borderColor: "#dee2e6",
                        backgroundColor: "#f8f9fa",
                      }}
                    >
                      <i className="fa-solid fa-book-open text-muted fa-2x mb-2 opacity-50"></i>
                      <p className="text-muted mb-0">No books selected yet.</p>
                      {selectedCard && !effectiveBookBankMode && memberAge !== null && (
                        <p className="text-dark small mt-2">
                          Books filtered for age {memberAge} years
                        </p>
                      )}
                    </div>
                  ) : (
                    <Row className="g-3">
                      {selectedBooks.map((book) => (
                        <Col xl={6} key={book.value}>
                          <div className="p-3 border rounded-3 d-flex justify-content-between align-items-center position-relative bg-white shadow-sm">
                            <div className="d-flex align-items-center">
                              <div
                                className="me-3 d-flex align-items-center justify-content-center rounded bg-light"
                                style={{ width: "50px", height: "50px" }}
                              >
                                <i className="fa-solid fa-book text-primary fa-lg"></i>
                              </div>
                              <div>
                                <div
                                  className="fw-bold text-dark text-truncate text-uppercase"
                                  style={{ maxWidth: "200px", fontSize: "14px" }}
                                >
                                  {book.data.title}
                                </div>
                                <div className="text-muted" style={{ fontSize: "12px" }}>
                                  ISBN: {book.data.isbn || "N/A"}
                                </div>
                                <div className="text-muted" style={{ fontSize: "12px" }}>
                                  Author: {book.data.author_name || "Unknown"}
                                </div>
                              </div>
                            </div>
                            <Button
                              variant="light"
                              className="text-danger border-0 shadow-none bg-transparent p-0"
                              onClick={() => {
                                setSelectedBooks((prev) =>
                                  prev.filter((x) => x.value !== book.value)
                                );
                                setSelectedCopies(prev => {
                                  const updated = { ...prev };
                                  delete updated[book.value];
                                  return updated;
                                });
                              }}
                            >
                              <i className="fa-solid fa-trash-can" style={{ fontSize: "1.1rem" }}></i>
                            </Button>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>

                <hr style={{ borderColor: "#f0f0f0" }} />

                <Row className="g-3 align-items-end">
                  <Col md={4}>
                    <Form.Label className="fw-bold small text-muted text-uppercase">
                      Issue Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={issueDate}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => {
                        setIssueDate(e.target.value);
                        setAutoCalculated(false);
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Label className="fw-bold small text-muted text-uppercase">
                      Due Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={dueDate}
                      min={issueDate}
                      readOnly={!effectiveBookBankMode}
                      max={!effectiveBookBankMode ? new Date().toISOString().split("T")[0] : undefined}
                      onChange={(e) => {
                        setDueDate(e.target.value);
                        setAutoCalculated(true);
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <Button
                      className="btn btn-custom"
                      style={{
                        backgroundColor: `var(--primary-color)`,
                      }}
                      onClick={handleIssue}
                      disabled={
                        processing ||
                        selectedBooks.length === 0 ||
                        !selectedCard ||
                        (memberInfo && !memberInfo.is_active) ||
                        (selectedCard && selectedBooks.length > getRemainingForMode())
                      }
                    >
                      {processing ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            className="me-2"
                          />{" "}
                          Processing...
                        </>
                      ) : (
                        <>
                          <i className=" fa-solid fa-book me-2"></i>
                          Confirm Issue
                        </>
                      )}
                      <Form.Text className="m-1 text-white small">
                        {confirmDays} days
                      </Form.Text>
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default BulkIssue;